module.exports = __webpack_public_path__ + "img/Zahlungsmethode_Black.9c496605.png";